import _get from 'lodash/get';
import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router';

import Home from './Home';
import StudentGradebookContainerWrapper from './components/StudentGradebookContainer';
import InstructorGradebookRoute from './components/InstructorGradebookContainer/InstructorGradebookRoute/InstructorGradebookRoute';
import IClickerCourseCreateRedirectPage from './components/modals/LinkReefDialog/IClickerCourseCreateRedirectPage/IClickerCourseCreateRedirectPage';
import SearchAcrossSectionsRoute from './components/SearchAcrossSectionsContainer/SearchAcrossSectionsRoute/SearchAcrossSectionsRoute';
import FeatureFormWrapper from './components/FeatureForm';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/iclicker-course-create-redirect"
          element={<IClickerCourseCreateRedirectPage />}
        />
        <Route
          path="/courses/:courseId/student"
          element={<StudentGradebookContainerWrapper />}
        />
        <Route
          path="/courses/:courseId/instructor/:isSectionManager?/:isGatewayEnabled?/:isRestrictedSection?/:courseShortName?"
          element={<InstructorGradebookRoute />}
        />
        <Route path="/chat/:courseId" element={<SearchAcrossSectionsRoute />} />
        <Route path="/features/:feature" element={<FeatureFormWrapper />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
